export default __webpack_public_path__ + "static/media/icon-menu.ea2bfba6.svg";